import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";
import "./books.css";

function BooksPage(){
    return (
        <ContentOverlay
        heading={ <h3 style={{textAlign:"center"}}>Books</h3> }
        text_content={<div><ol>
            <li>
            <p ><strong>Title:</strong>Surface Temperature Data over Indian Region (2023)</p>
           
            <p ><strong>Author: </strong>Sandeep Pattnaik</p>
            <p ><strong>Publisher: </strong>LAP LAMBERT Academic Publishing</p>
            <p ></p></li></ol>
            <ol start="2">
            <li>
            <p ><strong>Title: </strong>Thermal Evaluation of Indoor Climate and Energy Storage in Buildings (2024)</p>
           
            <p ><strong>Author: </strong>Shailendra Kumar Shukla</p>
            <p ><strong>Publisher: </strong>CRC Pr I Llc</p>
            <p ><u><a href="https://doi.org/10.1201/9781003415695">https://doi.org/10.1201/9781003415695</a></u></p>
            <p ></p></li></ol>
            <ol start="3">
            <li>
            <p ><strong>Title: </strong>Land Surface - Atmosphere Interactions for Climate Modeling (1990)</p>
           
            <p ><strong>Author: </strong>E.F. Wood</p>
            <p ><strong>Publisher: </strong>Springer</p>
            <p ></p></li></ol>
            <ol start="4">
            <li>
            <p ><strong>Title: </strong>Surface Meteorological Instruments and Measurement Practices (2009)</p>
           
            <p ><strong>Author: </strong>G.P. Srivastava</p>
            <p ><strong>Publisher: </strong>Atlantic </p>
            <p ></p></li></ol>
            <ol start="5">
            <li>
            <p ><strong>Title: </strong>Climate Change and Its Impact on India: Climate Change and Its Impact on India (2012)</p>
           
            <p ><strong>Author: </strong>Jamil Ahmad</p>
            <p ><strong>Publisher: </strong>Lap Lambert Academic Publishing</p>
            <p ></p></li></ol>
            <ol start="6">
            <li>
            <p ><strong>Title:</strong>Climate Change and Agriculture Over India (2010)</p>
           
            <p ><strong>Author:</strong>G. S. L. H. V. Prasada Rao, G.G.S.N. RAO, and V.U.M. RAO</p>
            <p ><strong>Publisher:</strong>Prentice-Hall India</p>
            <p ></p></li></ol>
            <ol start="7">
            <li>
            <p ><strong>Title:</strong>Land Use Planning and the Urban Heat Island (2015)</p>
           
            <p ><strong>Author: </strong>Kim Jun-Pill</p>
            <p ><strong>Publisher:</strong>Omni Scriptum Publishing</p>
            <p ></p></li></ol>
            <ol start="8">
            <li>
            <p ><strong>Title: </strong>Improve human thermal comfort through spatial climate adaptation (2018)</p>
           
            <p ><strong>Author: </strong>Flavia Simona Cosoveanu</p>
            <p ><strong>Publisher:</strong>LAP LAMBERT Academic Publishing </p>
            <p ></p></li></ol>
            <ol start="9">
            <li>
            <p ><strong>Title: </strong>Climate Action India (2025)</p>
           
            <p ><strong>Author: </strong>Tuhin A. Sinha andKaviraj Singh</p>
            <p ><strong>Publisher: </strong>Blueone Ink</p>
            <p ></p></li></ol>
            <ol start="10">
            <li>
            <p ><strong>Title: </strong>The Climate Solution (2019)</p>
           
            <p ><strong>Author: </strong>Mridula Ramesh</p>
            <p ><strong>Publisher: </strong>Hachette Book</p>
            <p ></p></li></ol>
            <ol start="11">
            <li>
            <p ><strong>Title: </strong>COVID-19 and Land Surface Temperature (2022)</p>
           
            <p ><strong>Author: </strong>Smitha Chandran S</p>
            <p ><strong>Publisher: </strong>LAP LAMBERT Academic Publishing</p>
            <p ></p></li></ol>
            <ol start="12">
            <li>
            <p ><strong>Title:</strong>Land Use Impacts On Climate(2015)</p>
           
            <p ><strong>Author: </strong>Manoj Negi and Jyoti Monga</p>
            <p ><strong>Publisher: </strong>Scitus</p>
            <p ></p></li></ol>
            <ol start="13">
            <li>
            <p ><strong>Title: </strong>Climate Change and Natural Resources: A Study of Indian Desert (2018)</p>
           
            <p ><strong>Author: </strong>H.S. Sharma</p>
            <p ><strong>Publisher: </strong>Concept Publishing Company Pvt. Ltd.</p>
            <p ></p></li></ol>
            <ol start="14">
            <li>
            <p ><strong>Title: </strong>Himalayan Weather and Climate and Their Impact On The Environment(2019)</p>
           
            <p ><strong>Author: </strong>Dimri A P</p>
            <p ><strong>Publisher: </strong>Springer</p>
            <p ><u><a href="https://doi.org/10.1007/978-3-030-29684-1">https://doi.org/10.1007/978-3-030-29684-1</a></u></p>
            <p ></p></li></ol>
            <ol start="15">
            <li>
            <p ><strong>Title: </strong>Forests and Climate Change in India: Vulnerability, Mitigation and Adaptation (2016)</p>
           
            <p ><strong>Author: </strong>Ashwani Kumar</p>
            <p ><strong>Publisher: </strong>M/s Bishen Singh Mahendra Pal Singh</p>
            <p ></p></li></ol>
            <ol start="16">
            <li>
            <p ><strong>Title: </strong>Agro-Climatic Regional Planning in India (1996)</p>
           
            <p ><strong>Author: </strong>S.P. Kashyap, G.S. Guha, D.N. Basu</p>
            <p ><strong>Publisher: </strong>Concept Publishing Company Pvt. Ltd.</p>
            <p ></p></li></ol>
            <ol start="17">
            <li>
            <p ><strong>Title: </strong>Assessment of Climate Change Over the Indian Region (2020)</p>
           
            <p ><strong>Author: </strong>R. Krishnan, J. Sanjay, Chellappan Gnanaseelan, Milind Mujumdar, Ashwini Kulkarni, Supriyo Chakraborty</p>
            <p ><strong>Publisher: </strong>Springer </p>
            <p ><u><a href="https://doi.org/10.1007/978-981-15-4327-2_1">https://doi.org/10.1007/978-981-15-4327-2_1</a></u></p>
            <p ></p></li></ol>
            <ol start="18">
            <li>
            <p ><strong>Title:</strong>Climate Change Impacts Responses and Sustainability in the Indian Himalaya (2022)</p>
           
            <p ><strong>Author:</strong>Rani Seema and Rajesh Kumar</p>
            <p ><strong>Publisher: </strong>Rawat Publications</p>
            <p ></p></li></ol>
            <ol start="19">
            <li>
            <p ><strong>Title:</strong>Climate Change in India (2024)</p>
           
            <p ><strong>Author: </strong>Neloy Khare</p>
            <p ><strong>Publisher: </strong>CRC Press</p>
            <p ></p></li></ol>
            <ol start="20">
            <li>
            <p ><strong>Title: </strong>Remote Sensing Monitoring of Land Surface Temperature (LST) (2022)</p>
           
            <p ><strong>Author:</strong>Juan Manuel S&aacute;nchez, C&eacute;sar Coll and Raquel Nicl&ograve;s</p>
            <p ><strong>Publisher: </strong>MDPI books</p>
            <p ><u><a href="https://doi.org/10.3390/books978-3-0365-1427-7">https://doi.org/10.3390/books978-3-0365-1427-7</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="21">
            <li>
            <p ><strong>Title: </strong>Satellite Remote Sensing of Global Land Surface Temperature: Definition, Methods, Products, and Applications (2023)</p>
           
            <p ><strong>Author: </strong>Zhao-Liang Li,Hua Wu, Si-Bo Duan and Wei Zhao</p>
            <p ><strong>Publisher: </strong>American Geophysical Union (AGU)</p>
            <p ><u><a href="https://doi.org/10.1029/2022RG000777">https://doi.org/10.1029/2022RG000777</a></u></p>
            <p ></p></li></ol>
            <ol start="22">
            <li>
            <p ><strong>Title: </strong>Taking the Temperature of the Earth (2019)</p>
           
            <p ><strong>Author: </strong>Glynn C. Hulley and Darren Ghent</p>
            <p ><strong>Publisher: </strong>Elsevier</p>
            <p ><u><a href="https://doi.org/10.1016/C2017-0-01600-2">https://doi.org/10.1016/C2017-0-01600-2</a></u></p>
            <p ></p></li></ol>
            <ol start="23">
            <li>
            <p ><strong>Title: </strong>Thermal and Optical Remote Sensing: Evaluating Urban Green Spaces and Urban Heat Islands in a Changing Climate (2023)</p>
           
            <p ><strong>Author: </strong>John O. Odindi, Elhadi Adam, Elfatih M. Abdel-Rahman and Yuyu Zhou</p>
            <p ><strong>Publisher: </strong>MDPI books</p>
            <p ><u><a href="https://doi.org/10.3390/books978-3-0365-6276-6">https://doi.org/10.3390/books978-3-0365-6276-6</a></u></p>
            <p ></p></li></ol>
            <ol start="24">
            <li>
            <p ><strong>Title: </strong>Validation and Reconstruction of Remote Sensing Land Surface Temperature Products (2024)</p>
           
            <p ><strong>Author:</strong>Wenping Yu, Yuechen Li, Xujun Han, Lei Fan, Wei Zhou, Mingguo Ma andWeiyu Shi</p>
            <p ><strong>Publisher: </strong>Springer Singapore</p>
            <p ><u><a href="https://doi.org/10.1007/978-981-97-4178-6">https://doi.org/10.1007/978-981-97-4178-6</a></u></p></li></ol></div>
            
        }
        />

    )
}
export default BooksPage;